import { AVAILABLE } from './availabilityTypes';

/**
 * Returns boolean whether any races charity tickets available.
 */
export default (races = []) =>
  [].concat(
    ...races
      .filter(r => !!r.tickets)
      .map(r =>
        r.tickets.tickets.filter(
          t => t.charityTickets === true && t.availability.type === AVAILABLE,
        ),
      ),
  ).length > 0;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/racesHaveAvailableCharityTickets.js